
































import { Component, Vue } from 'vue-property-decorator';
import social from '@/components/social.vue';
@Component({
  components: {
    social,
  },
})
export default class Home extends Vue {}
